// extracted by mini-css-extract-plugin
export default {"figure":"styles_figure__ofKgA","image":"styles_image__-GIjf","captionImage":"styles_captionImage__J8ub6"};